import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['screen', 'panoramaThumb']
  initialize () {
    const panoramaThumbImages = this.panoramaThumbTarget.querySelectorAll('img')
    const screen = this.screenTarget
    panoramaThumbImages.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (typeof pannellum !== 'undefined') {
          pannellum.viewer(screen, {
            panorama: thumb.getAttribute('data-path'),
            autoLoad: true,
            compass: false,
          })
          panoramaThumbImages.forEach(function (thumb) { thumb.classList.remove('viewcomponent::site::pages::facility::panorama::mobile::active') })
          thumb.classList.add('viewcomponent::site::pages::facility::panorama::mobile::active')
        }
      })
    })
    panoramaThumbImages[0].click()
  }
}
